export default __webpack_public_path__ + "static/media/player_4_eliminated.d816a1b8.png";